export const WORKSPACE_ROLES = {
  ADMIN: 'admin',
  MEMBER: 'member',
};
